// prettier-ignore
module.exports = {
  SKIMLINKS_CODE: '34276X922231',
  AMP_SKIMLINKS_CODE:'34276X1572708',
  AMAZON_AFFILIATE_TAG: 'apartmentth0a-20',
  NARRATIV_ACCOUNT_NAME: 'apartmenttherapy',
  OUTBRAIN_TEMPLATE: 'ApartmentTherapy',
  OUTBRAIN_WIDGETS: {
    desktop: 'AR_8',
    mobile: 'MB_2'
  },
  AMP_OUTBRAIN_WIDGET_IDS: 'AMP_1',
  COMSCORE_SLUG: 'apartmenttherapy',
  TWITTER_HANDLE: 'AptTherapy',
  PINTEREST_TAG_ID: '2614341160483',
  FACEBOOK_PIXEL_ID: '531267817007380',
  ALGOLIA_SITE_TAG: 'Apartment Therapy',
  ALGOLIA_INDEX: 'gen-posts',
  AUTH0_KEY_PREFIX: 'https://www.apartmenttherapy.com/',
  AMP_FB_APP_ID: '1876716989318650',
  PARSELY_SITE: 'apartmenttherapy.com',
  GA_ID: 'UA-821548-1',
  AHREFS_SITE_VERIFICATION: 'aa7e6ad938f66b4cf3bc7ae24d2a85cc16647606df7568a2f2b5c1109b9d81fd',
  POCKET_SITE_VERIFICATION: 'b6b063df97d6ce546dc847fe053b32',
  MSAPPPLICATION_TILE_COLOR: '#F12330',
  FACEBOOK_PAGES_CHANNEL_1: '30065974282',
  FACEBOOK_PAGES_CHANNEL_2: '220617808366047',
  SAILTHRU_CUSTOMER_ID: '0b529c70e1cce618c1826e8ac9255097'
};
